
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.6094 8.6573C17.9637 8.29689 18.0887 7.76794 17.9359 7.27624C17.7827 6.78454 17.3837 6.43354 16.8936 6.35905L12.5353 5.69805C12.3496 5.66984 12.1893 5.54832 12.1064 5.37263L10.1579 1.25091C9.9391 0.787798 9.49505 0.5 9.00018 0.5C8.50567 0.5 8.06163 0.787798 7.84284 1.25091L5.89401 5.37301C5.81111 5.5487 5.65036 5.67021 5.46474 5.69843L1.10644 6.35942C0.616618 6.43354 0.217263 6.78491 0.0640814 7.27662C-0.0887402 7.76832 0.0363285 8.29727 0.390629 8.65767L3.54402 11.866C3.67846 12.0029 3.74009 12.2 3.70837 12.3927L2.96445 16.9229C2.89849 17.3217 2.99869 17.7096 3.24594 18.0154C3.63016 18.4921 4.30092 18.6373 4.83723 18.3431L8.7349 16.204C8.89782 16.1148 9.1029 16.1156 9.26546 16.204L13.1635 18.3431C13.3531 18.4473 13.5553 18.5 13.764 18.5C14.1449 18.5 14.5061 18.3232 14.7544 18.0154C15.002 17.7096 15.1019 17.321 15.0359 16.9229L14.2916 12.3927C14.2599 12.1997 14.3215 12.0029 14.456 11.866L17.6094 8.6573Z","fill":"#FFC575"}})])
          )
        }
      }
    